import { useEffect, useState } from "react";

interface Pagination {
    offset: number;
    limit: number;
    page: number;
}

export function usePagination<T>(
    list: { results: T[] } | undefined,
) {
    const [dataSource, setDataSource] = useState<T[]>([]);
    const [pagination, setPagination] = useState<Pagination>({ page: 0, offset: 0, limit: 10 });

    useEffect(() => {
        setDataSource(list?.results ?? []);
    }, [list]);


    const handleChangePage = (_: unknown, newPage: number) => {
        setPagination((prev) => ({ ...prev, offset: prev.limit * newPage, page: newPage }));
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPagination((prev) => ({ ...prev, limit: parseInt(event.target.value, 10), offset: 0, page: 0 }));
    };

    const resetPage = () => {
        setPagination((prev) => ({ ...prev, offset: 0, page: 0 }));
    }

    const resetDataSource = () => {
        setDataSource([]);
    }

    return { dataSource, pagination, resetPage, handleChangePage, handleChangeRowsPerPage, resetDataSource };
}
